import React, { useState, useEffect } from "react";
import QueueContainer from "../../../Containers/DashboardContainer/Body/QueueContainer";
import GeneralQueueComponent from "./GeneralQueueComponent";
import "./CSS/QueuesComponent.css";

const QueuesComponent = (props) => {
  const [queueMetricsById, setQueueMetricsById] = useState({});
  const [agentStatesById, setAgentStatesById] = useState({});
  const [totalMetrics, setTotalMetrics] = useState({});
  const [totalAgentStates, setTotalAgentStates] = useState({});

//màj les métrics quand un queue se modifie 
  const updateQueueMetrics = (queueId, queueMetrics) => {
    
    setQueueMetricsById((prevMetrics) => {
      const updatedMetrics = { ...prevMetrics, [queueId]: queueMetrics };
      return updatedMetrics;
    });
  };
//màj les états quand un queue se modifie 
  const updateAgentStates = (queueId, agentState) => {
    setAgentStatesById((prevStates) => {
      const updatedStates = { ...prevStates, [queueId]: agentState };
      return updatedStates;
    });
  };
    //calculer les métrics global de tous les queues
    const calculateGlobalMetrics = () => {
      let total = {
        todayCalls: 0,
        callsInQueue: 0,
        abandonRate: 0,
        averageWaitTime: 0,
        longestWait: 0,
        overflowRate: 0,
        sla: 0,
        todayChats: 0,
        tasksInQueue: 0,
        slaChat: 0,
        averageWaitTimeChat: 0,
        longestWaitChat: 0,
      };
    
      let totalAbandonedCalls = 0;
      let totalQueueFallback = 0;
      let totalSlaReached = 0;
      let totalSlaReachedChat = 0;
    
      let countWaitTime = 0;
      let countWaitTimeChat = 0;
    
      Object.values(queueMetricsById).forEach((metrics) => {
        total.callsInQueue += metrics.callsInQueue;
        total.tasksInQueue += metrics.tasksInQueue;
        total.longestWait = Math.max(total.longestWait, metrics.longestWait);
        total.todayCalls += metrics.todayCalls;
        total.todayChats += metrics.todayChats;
        total.longestWaitChat = Math.max(total.longestWaitChat, metrics.longestWaitChat);
    
        if (metrics.averageWaitTime > 0) {
          total.averageWaitTime += metrics.averageWaitTime;
          countWaitTime++;
        }
    
        if (metrics.averageWaitTimeChat > 0) {
          total.averageWaitTimeChat += metrics.averageWaitTimeChat;
          countWaitTimeChat++;
        }
    
        totalAbandonedCalls += metrics.abandonedCall || 0;
        totalQueueFallback += metrics.queueFallback || 0;
        totalSlaReached += metrics.slaReached || 0;
        totalSlaReachedChat += metrics.slaReachedChat || 0;
      });
    
      // Calcul des taux globaux
      total.abandonRate = total.todayCalls ? (totalAbandonedCalls / total.todayCalls) * 100 : 0;
      total.overflowRate = total.todayCalls ? (totalQueueFallback / total.todayCalls) * 100 : 0;
      total.sla = total.todayCalls ? (totalSlaReached / total.todayCalls) * 100 : 0;
      total.slaChat = total.todayChats ? (totalSlaReachedChat / total.todayChats) * 100 : 0;
    
      if (countWaitTime) {
        total.averageWaitTime /= countWaitTime;
      }
    
      if (countWaitTimeChat) {
        total.averageWaitTimeChat /= countWaitTimeChat;
      }
    
      setTotalMetrics(total);
    };
    
   /* const calculateGlobalMetrics = () => {
      let total = {
        todayCalls: 0,
        callsInQueue: 0,
        abandonRate: 0,
        averageWaitTime: 0,
        longestWait: 0,
        overflowRate: 0,
        sla: 0,
        todayChats: 0,
        tasksInQueue: 0,
        slaChat: 0,
        averageWaitTimeChat: 0,
        longestWaitChat: 0,
      };
  
      let totalAbandonedCalls = 0;
      let totalQueueFallback = 0;
      let totalSlaReached = 0;
      let totalSlaReachedChat = 0;
      let queueCount = Object.keys(queueMetricsById).length;
 
      Object.values(queueMetricsById).forEach((metrics) => {
        total.callsInQueue += metrics.callsInQueue;
        total.tasksInQueue += metrics.tasksInQueue;
        total.longestWait = Math.max(total.longestWait, metrics.longestWait);
        total.averageWaitTime += metrics.averageWaitTime;
        total.todayCalls += metrics.todayCalls;
        total.todayChats += metrics.todayChats;
        total.longestWaitChat = Math.max(total.longestWaitChat, metrics.longestWaitChat);
        total.averageWaitTimeChat += metrics.averageWaitTimeChat;

        // Somme des valeurs pour les taux globaux
        totalAbandonedCalls += metrics.abandonedCall || 0;
        totalQueueFallback += metrics.queueFallback || 0;
        totalSlaReached += metrics.slaReached || 0;
        totalSlaReachedChat += metrics.slaReachedChat || 0;
      });
  
      // Calcul des taux globaux
      total.abandonRate = total.todayCalls ? (totalAbandonedCalls / total.todayCalls) * 100 : 0;
      total.overflowRate = total.todayCalls ? (totalQueueFallback / total.todayCalls) * 100 : 0;
      total.sla = total.todayCalls ? (totalSlaReached / total.todayCalls) * 100 : 0;
      total.slaChat = total.todayChats  ? (totalSlaReachedChat / total.todayChats ) * 100 : 0;
  
      if (queueCount) {
        total.averageWaitTime /= queueCount;
        total.averageWaitTimeChat /= queueCount;
      }
      setTotalMetrics(total);
    };*/
  
 
  const calculateGlobalAgentStates = () => {
    let totalState = {
      READY: 0,
      "COFFEE BREAK": 0,
      "ADMIN WORK": 0,
      "OUT OF SHIFT": 0,
    };
  
    // Ajouter dynamiquement les nouveaux états présents dans agentStatesById
    Object.values(agentStatesById).forEach((states) => {
      Object.keys(states).forEach((state) => {
        if (!totalState.hasOwnProperty(state)) {
          totalState[state] = 0;
        }
        totalState[state] += states[state] || 0;
      });
    });
  
    setTotalAgentStates(totalState);
  };
  
  
  useEffect(() => {
    if(queueMetricsById){
      calculateGlobalMetrics();
    }
    if(agentStatesById ){
      calculateGlobalAgentStates();
    }
   
  }, [agentStatesById,queueMetricsById]);
 


  return (
    <div className="queues-container">
      <GeneralQueueComponent globalMetrics={totalMetrics} globalAgentState={totalAgentStates} />
      <div className="queues-container-wrapper">
      
        {props.queues &&
          Object.values(props.queues).map((queue) => (
            <QueueContainer
              key={queue.id}
              queue={queue}
              updateQueueMetrics={updateQueueMetrics}
              updateAgentStates={updateAgentStates}
              signalRConnection={props.signalRConnection} 
            />
          ))}
      </div>
    </div>
  );
};

export default QueuesComponent;